import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Footer from "../component/Footer";
import Header from "../component/Header";
import Contact from '../pages/Contact';
import About from "../pages/About";
import Services from "../pages/services/Services";
import Consulting from "../pages/services/Consulting";
import Implement from "../pages/services/Implement";
import Customization from "../pages/services/Customization";
import Development from '../pages/services/Development';
import Integration from "../pages/services/Integration";
import Maintenance from "../pages/services/Maintenance";
import SalesCloud from "../pages/services/SalesCloud";
import ServiceCloud from "../pages/services/ServiceCloud";
import MarketingCloud from "../pages/services/MarketingCloud";
import SalesforceCompanyNewYark from "../pages/services/SalesforceCompnayNewYark";
import Texas from "../pages/country/Texas";
import SalesforceSupport from "../pages/services/SalesforceSupport";
import Managed from "../pages/services/Managed";
import CommercialCloud from "../pages/services/CommercialCloud";
import CommunityCloud from "../pages/services/CommunityCloud";
import NonProfit from "../pages/services/NonProfit";
import FinencialServiceCloud from "../pages/services/FinencialServiceCloud";
import CPQ from "../pages/services/CPQ";
import EnstainAnalytics from "../pages/services/EnstainAnalytics";
import Career from "../component/career";
import CaseStudy from "../pages/CaseStudy";
import NewYork from "../pages/country/NewYork";
import Dubai from "../pages/country/Dubai";
import London from "../pages/country/London";
import Kuwait from "../pages/country/Kuwait";
import Seattle from "../pages/country/Seattle";
import Chicago from "../pages/country/Chicago";
import Paris from "../pages/country/Paris";
import Berlin from "../pages/country/Berlin";
import Melbourne from "../pages/country/Melbourne";
import Sydney from "../pages/country/Sydney";


export default function Router() {
    const [loading, setLoading] = useState(true)
    const [headerData, setHeaderData] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <BrowserRouter>
                {/* <Header setHeaderData={setHeaderData} /> */}
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/salesforce" element={<Services />} />
                    <Route path="/salesforce/consulting" element={<Consulting />} />
                    <Route path="/salesforce/implementation" element={<Implement />} />
                    <Route path="/salesforce/customization" element={<Customization />} />
                    <Route path="/salesforce/development" element={<Development />} />
                    <Route path="/salesforce/integration" element={<Integration />} />
                    <Route path="/salesforce/maintenance" element={<Maintenance />} />
                    <Route path="/salesforce/sales-cloud" element={<SalesCloud />} />
                    <Route path="/salesforce/service-cloud" element={<ServiceCloud />} />
                    <Route path="/salesforce/marketing-cloud" element={<MarketingCloud />} />

                    {/* <Route path="/salesforce/development-company-new-yark" element={<SalesforceCompanyNewYark />} /> */}
                    <Route path="/salesforce/support" element={<SalesforceSupport />} />
                    <Route path="/salesforce/managed" element={<Managed />} />
                    <Route path="/salesforce/commerce-cloud" element={<CommercialCloud />} />
                    <Route path="/salesforce/community-cloud" element={<CommunityCloud />} />
                    <Route path="/salesforce/non-profit" element={<NonProfit />} />
                    <Route path="/salesforce/finencial-service-cloud" element={<FinencialServiceCloud />} />
                    <Route path="/salesforce/cpq" element={<CPQ />} />
                    <Route path="/salesforce/einstein-analytics" element={<EnstainAnalytics />} />
                    <Route path="/career" element={<Career />} />
                    <Route path="/case-study" element={<CaseStudy />} />

                    {/* Countries */}

                    <Route path="/salesforce/development-company-in-new-york" element={<NewYork />} />
                    <Route path="/salesforce/development-company-in-texas" element={<Texas />} />
                    <Route path="/salesforce/development-company-in-dubai" element={<Dubai />} />
                    <Route path="/salesforce/development-company-in-london" element={<London />} />
                    <Route path="/salesforce/development-company-in-kuwait" element={<Kuwait />} />
                    <Route path="/salesforce/development-company-in-seattle" element={<Seattle />} />
                    <Route path="/salesforce/development-company-in-chicago" element={<Chicago />} />
                    <Route path="/salesforce/development-company-in-paris" element={<Paris />} />
                    <Route path="/salesforce/development-company-in-berlin" element={<Berlin />} />
                    <Route path="/salesforce/development-company-in-melbourne" element={<Melbourne />} />
                    <Route path="/salesforce/development-company-in-sydney" element={<Sydney />} />


                    {/* <Route path="*" element={<Route404 />} /> */}
                </Routes>
                <Footer headerData={headerData} />
            </BrowserRouter >
        </>
    );
}